<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col sm="12" md="10">
        <v-card>
          <v-toolbar flat>
            <v-toolbar-title class="headline">
              <v-icon left>mdi-routes-clock</v-icon>
              Incoming Materials
            </v-toolbar-title>
            <template v-slot:extension>
              <div class="caption">
                <v-icon small left>fas fa-info</v-icon>
                List of incoming materials to Forge Nano facilities.
                Tagged via projects so that Receiving and QC can determine the origin and actions for material arrivals.
              </div>
            </template>
          </v-toolbar>
          <v-data-table
            :items="items"
            :loading="loading"
            :headers="headers"
            :items-per-page="25"
          >
            <template v-slot:item.project.forgeID="{ item }">
              <ProjectNavigation :instance="item.project" />
            </template>
            <template v-slot:item.received="{ item }">
              <v-icon v-if="item.received" color="success">
                mdi-check-all
              </v-icon>
              <v-icon v-else color="error">far fa-times-circle</v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ProjectMaterial from "../../models/ProjectMaterial";
import ProjectNavigation from "../../components/Project/ProjectNavigation";
export default {
  name: "IncomingMaterialsListView",
  components: {ProjectNavigation},
  data() {
    return {
      loading: true,
      headers: [
        { text: 'Project', align: 'left', sortable: true, value: 'project.forgeID' },
        { text: 'Name', sortable: true, value: 'name' },
        { text: 'Received', sortable: true, value: 'received', align: 'center' },
        { text: 'Expected Amount', value: 'expected_quantity', align: 'right' } 
      ]
    }
  },
  computed: {
    items() {
      return ProjectMaterial.query().with('project').all()
    }
  },
  methods: {
    initialize() {
      this.loading = true;
      ProjectMaterial.$fetch().then(() => { this.loading = false})
    }
  },
  mounted() {
    this.initialize()
  }
}
</script>
